module.exports = __webpack_public_path__ + "img/jk.f2542d30.png";